import React from 'react';
import {FormControl, InputLabel, MenuItem, Select} from '@mui/material';

const statuses: { id: string, label: string, disabled: boolean }[] =
  [
    {id: 'under_review', label: 'На проверке', disabled: false},
    {id: 'approved', label: 'Одобрена', disabled: false},
    {id: 'rejected', label: 'Отклонена', disabled: false},
    {id: 'deleted', label: 'Удалена', disabled: false},
    {id: 'delayed_publication', label: 'Ожидает публикации', disabled: true},
  ]

interface ArticleStatusSelectorProps {
  value: string;
  onChange: (newStatus: string) => void;
  label?: string;
  disabled?: boolean
}

export const ArticleStatusSelector: React.FC<ArticleStatusSelectorProps> = ({
                                                                              value,
                                                                              onChange,
                                                                              disabled,
                                                                              label = 'Статус статьи',
                                                                            }) => {
  return (
    <FormControl fullWidth>
      <InputLabel id="article-status-label">{label}</InputLabel>
      <Select
        labelId="article-status-label"
        value={value}
        label={label}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value as string)}
        margin="dense"
        size="small"
      >
        {statuses.map((status) => (
          <MenuItem disabled={status.disabled} key={status.id} value={status.id}>
            {status.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
